import { render, staticRenderFns } from "./techPro1Rich.vue?vue&type=template&id=0325fb23&"
import script from "./techPro1Rich.vue?vue&type=script&lang=js&"
export * from "./techPro1Rich.vue?vue&type=script&lang=js&"
import style0 from "./techPro1Rich.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports